import React, { useEffect, useRef, useState } from "react";
import styles from "./astrologer_tarot.module.css";
import { Box, Button, Link, Modal, Typography } from "@mui/material";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
// import ReactPlayer from "react-player";

import dynamic from 'next/dynamic'
import Head from "next/head";
const ReactPlayer = dynamic(() => import("react-player"), { ssr: false });




export default function Astrologer_main() {
    //  ======== wheel modal =======
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>


        <Head>
    <title>Travis P. Schultz - Tarot Reader & Astrologer Profile | School of Our Divine Infinite Being</title>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1.0"
    ></meta>
    <meta
      name="keywords"
      content="Travis P. Schultz, Tarot Reader, Astrology Readings, Natal Chart Consultation, Relationship Chart, Solar Return, Saturn Return, Transit Readings, Professional Diviner"
    ></meta>
    <meta
      property="og:title"
      content="Astrology & Tarot Readings by Travis P. Schultz"
    ></meta>
    <meta property="og:type" content="website"></meta>
    <meta
      property="og:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/Tarot-Reader-Astrologer_img.webp"
    ></meta>
    <meta
      property="og:image:alt"
      content="A profile page for professional tarot reader and astrologer Travis P. Schultz, showing her photo and the various astrology and tarot readings she offers."
    ></meta>
    <meta
      property="og:description"
      content="Book a professional astrology or tarot reading with Travis P. Schultz. Specializing in tarot counselling, natal charts, relationship charts, solar returns, and transit consultations. Purchase your reading today."
    ></meta>

    <meta property="og:image:width" content="1200"></meta>
    <meta property="og:image:height" content="627"></meta>
    <meta
      property="og:url"
      content="https://www.divineinfinitebeing.com/astrologer-tarot-profile"
    ></meta>

    <meta name="twitter:card" content="summary_large_image"></meta>
    <meta
      property="twitter:image"
      content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/Tarot-Reader-Astrologer_img.webp"
    ></meta>
    <meta
      property="twitter:image:alt"
      content="A profile page for professional tarot reader and astrologer Travis P. Schultz, showing her photo and the various astrology and tarot readings she offers."
    ></meta>
    <meta
      name="twitter:url"
      content="https://www.divineinfinitebeing.com/astrologer-tarot-profile"
    ></meta>
    <meta
      name="twitter:title"
      content="Astrology & Tarot Readings by Travis P. Schultz"
    ></meta>
    <meta
      name="twitter:description"
      content="Book a professional astrology or tarot reading with Travis P. Schultz. Specializing in tarot counselling, natal charts, relationship charts, solar returns, and transit consultations. Purchase your reading today."
    ></meta>
    <link rel="canonical" href="https://www.divineinfinitebeing.com/astrologer-tarot-profile" />
</Head>
            <div className="astrologer">
                <div className={styles.astrologer_main}>
                    {/* -------------------------------------rajdeep----------------------------------------------------- */}
                    {/* <!------rotathewheelblockone-------> */}
                    <div className={styles.rotathewheelblockone}>
                        {/* <!------Main Banner section-------> */}
                        <div className={styles.asmainwrapper}>
                            <div className={styles.rotathewheelblockoneleft}>
                                <div className={styles.bannerLogo}>
                                    <span className={styles.logoviewlink} onClick={handleOpen}>
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" />
                                    </span>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" />
                                </div>
                                <h1 data-text="SCHOOL OF THE DIVINE">SCHOOL OF OUR DIVINE </h1>
                                <h1 data-text="infinite being">INFINITE BEING</h1>

                                <h2>
                                    Polytheistic Monism - Divine Theurgy - Oracle to the Gods
                                </h2>
                                <div
                                    className= {`${styles.yllw_bar} ${styles.bannerboxtxt}`}
                                >
                                    <div className={`${styles.rotathewheelbottombannerbg}`}></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.tf_block1_main}>

                        <div className={styles.columns_wrpr}>
                            <div className={styles.columns_text}>
                                <span className={styles.columns_flex}>
                                    <h1>TAROT READER PROFILE DETAILS</h1>
                                </span>
                            </div>
                        </div>

                        <div className={styles.common_width}>
                            <div className={styles.tf_block1_sub}>


                                <div className={styles.tarot_profile_flx}>
                                    <div className={styles.tarot_profile_left}>
                                        <div className={styles.tarot_profile_img}>
                                            <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block1/tarot_profl_girls_img.webp" />
                                        </div>
                                    </div>
                                    <div className={styles.tarot_profile_right}>
                                        <div className={styles.tarot_prof_hdr}>
                                            <h2>PROFILE INFORMATION</h2>
                                        </div>
                                        <div className={styles.tarot_prof_about}>
                                            <h4>Travis P. Schultz</h4>
                                            <div className={styles.abt_flx}>
                                                <h5>
                                                    <span>About :</span>
                                                </h5>
                                                <h5>
                                                    Lorem ipsum is a placeholder text commonly used to
                                                    demonstrate the visual form of a document or a
                                                    typeface without relying on meaningful content. Lorem
                                                    ipsum is a placeholder text commonly used or a
                                                    typeface without relying on meaningful content. Lorem
                                                    ipsum is a placeholder text commonly usedto
                                                    demonstrate the visual form of a document or a
                                                    typeface without relying on meaningful{" "}
                                                    <span className={styles.span_rd_mr}>
                                                        ....Read more
                                                    </span>
                                                </h5>
                                            </div>
                                            <h5>
                                                <span>Specialization : </span>Tarot Reader counselling
                                            </h5>
                                            <h5>
                                                <span>Known Language : </span>English, Spanish{" "}
                                                <span className={styles.span_rd_mr}>+ 1 more</span>
                                            </h5>
                                            <div>
                                                <Link><img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block1/facebook_img.webp" />{" "} </Link>
                                                <Link> <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block1/insta_img.webp" />{" "} </Link>
                                                <Link> <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block1/twitter_img.webp" /> </Link>
                                            </div>
                                        </div>
                                        <img
                                            className={styles.abs_img}
                                            src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block1/69_img.webp"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.tf_block1_1_main}>

                        <div className={styles.columns_wrpr}>
                            <div className={styles.columns_text}>
                                <span className={styles.columns_flex}>
                                    <h1>ASTROLOGY products OFFERED</h1>
                                </span>
                            </div>
                        </div>
                        <div className={styles.common_width}>
                            <div className={styles.tf_block1_1_sub}>


                                <div className={styles.card_header}>
                                    <h2>PRODUCTS OFFERED FOR ONE-TIME</h2>
                                </div>

                                <div className={styles.card_wrapper}>
                                    <div className={styles.card_wrapper_flx}>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_1} ${styles.blu_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Natal chart and</h1>
                                                <h1>
                                                    consultation <span>(3 hours)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_2} ${styles.green_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Relationship cart and</h1>
                                                <h1>
                                                    consultation <span>(1 hours)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_3} ${styles.red_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Solar return</h1>
                                                <h1>
                                                    consultation <span>(1 hour)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_4} ${styles.red_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Transit</h1>
                                                <h1>
                                                    consultation <span>(1 hour)</span>
                                                </h1>
                                                <div className={`${styles.card_bullet}`}>
                                                    <p>
                                                        Weekly Transit Report
                                                    </p>
                                                    <p>Month Transit Report</p>
                                                    <p>Year Transit Report... <span>Read more</span></p>
                                                </div>
                                                
                                                   
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_5}  ${styles.blu_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1> Saturn return </h1>
                                                <h1>
                                                    consultation <span>(21 / 31) (1 hour)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_6} ${styles.green_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1> Uranus Opposition </h1>
                                                <h1>consultation</h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_7}  ${styles.blu_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1> Venus returns </h1>
                                                <h1>
                                                    consultation <span>(every year) (1 hour)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_8} ${styles.green_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Mars return </h1>
                                                <h1>
                                                    <span>(every year) (1 hour)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>

                                        <div
                                            className={`${styles.card_block} ${styles.card_block_9} ${styles.red_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Activation of special features </h1>
                                                <h1>
                                                    including true nodes, Chiron <span>(1 hour)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={styles.card_header}>
                                    <h2>PACKAGES OFFERED</h2>
                                </div>

                                <div className={styles.card_wrapper}>
                                    <div className={styles.card_wrapper_flx}>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_10} ${styles.green_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Natal plus Relationship package</h1>
                                                <h1>
                                                    <span>(2 separate appointments) </span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_11} ${styles.red_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Natal plus Solar return</h1>
                                                <h1>
                                                    <span>(2 separate appointments)</span>
                                                </h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_12} ${styles.blu_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Monthly Transit </h1>
                                                <h1>consultation</h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_13} ${styles.blu_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>Monthly Transit </h1>
                                                <h1>consultation</h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                        <div
                                            className={`${styles.card_block} ${styles.card_block_14} ${styles.vio_card}`}
                                        >
                                            <div className={`${styles.card_block_sub}`}>
                                                <h1>YEARLY Transit </h1>
                                                <h1>consultation</h1>
                                                <p>
                                                    Lorem ipsum, or lipsum as it is sometimes known,
                                                    dummy... <span>Read more</span>
                                                </p>
                                                <Link>BUY NOW</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                    <div className={styles.at_newblock_main}>
                        <div className={styles.columns_wrpr}>
                            <div className={styles.columns_flex}>
                                <div className={styles.columns_text}>
                                    <h1>testimonial</h1>
                                </div>
                            </div>
                        </div>
                        <div className={styles.common_width}>

                            <div className={styles.newblock_flex}>
                                <div className={styles.newblock_box1}>
                                    {/* <div className={styles.newblock_social_media}>
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_fb_iogo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_twt_logo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/ai_newblock_in_logo.webp" />
                                    </div> */}
                                    <div className={styles.box1_img_text}>

                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_box1_img.webp" />

                                        <div className={styles.box1_text}>
                                            <h1>Lorem Ipsum is </h1>
                                            <p>Lorem Ipsum is simply</p>

                                        </div>
                                        <div className={styles.newblock_social_media}>
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_fb_iogo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_twt_logo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/ai_newblock_in_logo.webp" />
                                    </div> 

                                    </div>
                                    <div className={styles.box1_sub_text}>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when
                                        </p>
                                    </div>
                                    <div className={styles.box1_textbutton}>
                                        <p>Date Sep - 01,09,2023</p>
                                        <div className={styles.newblock_button_box}>
                                            <Button>read more</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.newblock_box1}  ${styles.box2_img_bg}`}>
                                    <div className={styles.box1_img_text}>

                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_box2_img.webp" />

                                        <div className={`${styles.box1_text} ${styles.box2_text}`}>
                                            <h1>Lorem Ipsum is </h1>
                                            <p>Lorem Ipsum is simply</p>

                                        </div>
                                        <div className={styles.newblock_social_media}>
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_fb_iogo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_twt_logo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/ai_newblock_in_logo.webp" />
                                    </div> 

                                    </div>
                                    <div className={styles.box1_sub_text}>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when
                                        </p>
                                    </div>
                                    <div className={styles.box1_textbutton}>
                                        <p>Date Sep - 01,09,2023</p>
                                        <div className={styles.newblock_button_box}>
                                            <Button>read more</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${styles.newblock_box1}  ${styles.box3_img_bg}`}>
                                    <div className={styles.box1_img_text}>

                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_box3_img.webp" />

                                        <div className={`${styles.box1_text} ${styles.box3_text}`}>
                                            <h1>Lorem Ipsum is </h1>
                                            <p>Lorem Ipsum is simply</p>

                                        </div>
                                        <div className={styles.newblock_social_media}>
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_fb_iogo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_newblock_twt_logo.webp" />
                                        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/ai_newblock_in_logo.webp" />
                                    </div> 

                                    </div>
                                    <div className={styles.box1_sub_text}>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s when
                                        </p>
                                    </div>
                                    <div className={styles.box1_textbutton}>
                                        <p>Date Sep - 01,09,2023</p>
                                        <div className={styles.newblock_button_box}>
                                            <Button>read more</Button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className={styles.button_box}>
                                <Button>VIEW MORE</Button>
                            </div>
                        </div>
                    </div>
                    {/* -------------------------------------rajdeep----------------------------------------------------- */}
                    <div className={styles.block2_main}>
                        <div className={styles.columns_wrpr}>
                            <div className={styles.columns_flex}>
                                <div className={styles.columns_text}>
                                    <h1>IMAGE ADDED BY MATY M. VANDERMARK</h1>
                                </div>
                            </div>
                        </div>

                        <div className={styles.common_width}>
                            {/* <div className={styles.block2_sub}> */}

                            <div className={styles.block2_img}>
                                <div className={styles.box_img}>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at.block2_box1_img.webp" />
                                    <div className={styles.box_text}>
                                        <p>The Holy Spirit</p>
                                    </div>
                                </div>
                                <div className={styles.box_img}>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_block2_box2_img.webp" />
                                    <div className={styles.box_text}>
                                        <p>The Holy Spirit</p>
                                    </div>
                                </div>
                                <div className={styles.box_img}>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_block2_box3_img.webp" />
                                    <div className={styles.box_text}>
                                        <p>The Holy Spirit</p>
                                    </div>
                                </div>
                                <div className={styles.box_img}>
                                    <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block2/at_block2_box4_img.webp" />
                                    <div className={styles.box_text}>
                                        <p>The Holy Spirit</p>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.button_box}>
                                <Button>VIEW MORE</Button>
                            </div>

                            {/* </div> */}
                        </div>
                    </div>
                    <div className={styles.block3_main}>
                        <div className={styles.columns_wrpr}>
                            <div className={`${styles.columns_flex} ${styles.block3_flex2}`}>
                                <div className={styles.columns_text}>
                                    <h1>VIDEO ADDED BY MATY M. VANDERMARK</h1>
                                </div>
                            </div>
                        </div>

                        <div className={styles.common_width}>
                            <div className={styles.block3_imgandvideo}>
                                <div className={styles.video}>
                                    <ReactPlayer
                                        className={styles.page5_react_player}
                                        url="https://all-frontend-assets.s3.amazonaws.com/Timothy-Desmond-Nest/Timothy_purchase/Trailer.mp4"
                                        light="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/at_block3_video_img.webp"
                                        playing={true}
                                        controls={true}
                                        width="100%"
                                        height="100%"
                                    />
                                </div>
                                <div className={styles.block3_img_main}>
                                    <div className={styles.block3_img_flex}>
                                        <div className={styles.img_sub}>
                                            <div className={styles.imgandtext}>
                                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/at_block3_box1_img.webp" />
                                            </div>
                                            <div className={styles.text}>
                                                <p>Lorem ipsum dolor sit amet</p>
                                                <h1>adipiscing elit</h1>
                                                <h2>Nulla eleifend elit vitae lacus fermentum, </h2>
                                            </div>
                                        </div>
                                        <div className={styles.img_sub}>
                                            <div className={styles.imgandtext}>
                                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/ai_block3_box2_img.webp" />
                                            </div>
                                            <div className={styles.text}>
                                                <p>Lorem ipsum dolor sit amet</p>
                                                <h1>adipiscing elit</h1>
                                                <h2>Nulla eleifend elit vitae lacus fermentum, </h2>
                                            </div>
                                        </div>
                                        <div className={styles.img_sub}>
                                            <div className={styles.imgandtext}>
                                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/at_block3_box3_img.webp" />
                                            </div>
                                            <div className={styles.text}>
                                                <p>Lorem ipsum dolor sit amet</p>
                                                <h1>adipiscing elit</h1>
                                                <h2>Nulla eleifend elit vitae lacus fermentum, </h2>
                                            </div>
                                        </div>
                                        <div className={styles.img_sub}>
                                            <div className={styles.imgandtext}>
                                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/at_block3_box4_img.webp" />
                                            </div>
                                            <div className={styles.text}>
                                                <p>Lorem ipsum dolor sit amet</p>
                                                <h1>adipiscing elit</h1>
                                                <h2>Nulla eleifend elit vitae lacus fermentum, </h2>
                                            </div>
                                        </div>
                                        <div className={styles.img_sub}>
                                            <div className={styles.imgandtext}>
                                                <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/astrologer-tarot-profile/block3/at_block3_box5_img.webp" />
                                            </div>
                                            <div className={styles.text}>
                                                <p>Lorem ipsum dolor sit amet</p>
                                                <h1>adipiscing elit</h1>
                                                <h2>Nulla eleifend elit vitae lacus fermentum, </h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${styles.button_box} ${styles.button_box2}`}>
                                        <Button>
                                            VIEW MORE VIDEOS
                                            <img src="https://d37pbainmkhx6o.cloudfront.net/Timothy-Desmond-Nest/FreeTraining/expand_all_button.png" />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* =============== wheel modal ================ */}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="banner_modal_main"
            >
                <Box className="banner_modal_box">
                    <Typography
                        id="modal-modal-description" component="div"
                        sx={{ mt: 2 }}
                        className="modal_banner"
                    >
                        <div className="sub_modal_banner">
                            <span className="close_btn" onClick={handleClose}>
                                X
                            </span>
                            <img
                                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                                alt="bannerLogo"
                            />
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </>
    );
}
